export enum LayoutConfigurationEntityName {
  Group = 'group',
  Card = 'card',
  Variable = 'variable',
}
